import request from "@/config/utils/request";
export function getAppRole(data) {
  return request({
    url: "/apis/ebs/user/listPageAppUser", // 请求角色列表 联调入参 { "applicationId":106}  值106是组织管理
    method: "post",
    data
  });
}

export function saveRoleInfo(data) {
  return request({
    url: "/apis/ebs/role/saveRoleInfo", // 新建角色
    method: "post",
    data
  });
}

// 角色中用户
export function saveUserList(data) {
  return request({
    url: "/apis/ebs/role/saveUserList", // 新建角色中的成员[{userList autoCode}]
    method: "post",
    timeout: 30 * 1000,
    data
  });
}

export function removeUser(data) {
  return request({
    url: "/apis/ebs/role/removeUser", // 角色用户列表 删除用户{userRoleList:[],roleId:2}
    method: "post",
    timeout: 30 * 1000,
    data
  });
}

export function getUserList(data) {
  return request({
    url: "/apis/ebs/role/listAppUsers", // 角色用户列表 {roleId}
    method: "post",
    data
  });
}

export function getRoleMenu(data) {
  return request({
    url: "/apis/ebs/role/listRoleMenu", // 获取角色的菜单 {roleId}
    method: "post",
    data
  });
}

// export function editRoleMenu(data) {
//   return request({
//     url: "/apis/ebs/role/editRoleMenu", // 更新角色的菜单 {roleId resourceIds}
//     method: "post",
//     timeout: 30 * 1000,
//     data
//   });
// }

// 编辑角色接口
export function editRoleInfo(data) {
  return request({
    url: "/apis/ebs/role/editRoleInfo", // 通过id查询角色名称 {roleId}
    method: "post",
    data
  });
}

export function removeRole(data) {
  return request({
    url: "/apis/ebs/role/removeRole",
    method: "post",
    data,
    timeout: 30 * 1000
  });
}

export function getRoleInfo(data) {
  return request({
    url: "/apis/ebs/role/listThisRole", // 通过id查询角色名称 {roleId}
    method: "post",
    data
  });
}
//功能权限中功能菜单
export function getRoleMenuList(data) {
  return request({
    url: "/apis/ebs/jurisdiction/qryJurisdiction", // 通过id查询角色名称 {roleId}
    method: "post",
    data
  });
}
//功能权限菜单保存
// export function editRoleMenu(data) {
//   return request({
//     url: "/apis/ebs/role/editRoleMenu", // 更新角色的菜单 {roleId resourceIds}
//     method: "post",
//     timeout: 30 * 1000,
//     data
//   });
// }
export function editRoleMenu(data) {
  return request({
    url: "/apis/ebs/jurisdiction/updateJurisdiction", // 通过id查询角色名称 {roleId}
    method: "post",
    data
  });
}
//列表删除 http://dev01-emma.iccec.cn/apis/ebs/user/deleteAppUser
export function deleteAppUser(data) {
  return request({
    url: "/apis/ebs/user/deleteAppUser",
    method: "POST",
    data
  });
}
//角色管理列表请求
export function getRoleList(data) {
  return request({
    url: "/apis/ebs/role/listRoles",
    method: "POST",
    data
  });
}
//添加用户管理
export function addAppUser(data) {
  return request({
    url: "/apis/ebs/user/addAppUser",
    method: "POST",
    data
  });
}
//添加兼职/添加部门接口：http://dev01-emma.iccec.cn/apis/ebs/user/addUserPartyRelation
export function addUserPartyRelation(data) {
  return request({
    url: "/apis/ebs/user/addUserPartyRelation",
    method: "POST",
    data
  });
}
//成员维护添加成员
export function addBatchAppUser(data) {
  return request({
    url: "/apis/ebs/user/addBatchAppUser",
    method: "POST",
    data
  });
}
